import React from 'react';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItemButton, ListItemText, TextField, Typography } from '@mui/material';
import { EditableEquipmentItem } from './MemberEquipmentEditor';

interface MemberEquipmentModalProps {
  open: boolean;
  memberName: string;
  availableItems: EditableEquipmentItem[];
  selectedItems: EditableEquipmentItem[];
  onClose: () => void;
  onChange: (selectedIds: string[]) => void;
}

export const MemberEquipmentModal: React.FC<MemberEquipmentModalProps> = ({
  open, memberName, availableItems, selectedItems, onClose, onChange,
}) => {
  const [query, setQuery] = React.useState('');
  const [selectedIds, setSelectedIds] = React.useState<string[]>([]);
  const visible = availableItems.filter((item) => `${item.name} ${item.description ?? ''}`.toLowerCase().includes(query.trim().toLowerCase()));
  const grouped = visible.reduce<Record<string, EditableEquipmentItem[]>>((groups, item) => {
    const category = item.category ?? 'Special';
    (groups[category] ??= []).push(item);
    return groups;
  }, {});
  React.useEffect(() => {
    if (open) {
      setQuery('');
      setSelectedIds(selectedItems.map((item) => item.id));
    }
  }, [open]);
  return <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Edit Equipment - {memberName}</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField size="small" label="Search equipment" value={query} onChange={(event) => setQuery(event.target.value)} />
      <Typography variant="subtitle2">Equipment</Typography>
      {visible.length === 0 ? <Typography color="text.secondary">No equipment available.</Typography> : [['Weapon', 'Weapons'], ['Armour', 'Armour'], ['Special', 'Special'], ['Magic', 'Magic']].map(([category, label]) => {
        const categoryItems = grouped[category] ?? [];
        return categoryItems.length > 0 ? <Box key={category}>
        <Typography variant="subtitle2" sx={{ mt: 1 }}>{label}</Typography>
        <List dense>{categoryItems.sort((a, b) => a.name.localeCompare(b.name)).map((item) => <ListItemButton key={item.id} disabled={item.disabled && !selectedIds.includes(item.id)} onClick={() => { if (!item.disabled) setSelectedIds((current) => current.includes(item.id) ? current.filter((id) => id !== item.id) : [...current, item.id]); }}>
          <Checkbox checked={selectedIds.includes(item.id)} disabled={item.disabled} tabIndex={-1} />
          <ListItemText primary={item.name} secondary={item.disabledReason ?? item.description ?? undefined} />
        </ListItemButton>)}</List>
      </Box> : null;
      })}
    </DialogContent>
    <DialogActions><Button onClick={onClose}>Cancel</Button><Button variant="contained" onClick={() => { onChange(selectedIds); onClose(); }}>Save</Button></DialogActions>
  </Dialog>;
};
